import React, { FC, useState } from "react";
import { Table, Tooltip } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { useBmsSaleRoDetailModel } from "../bmsBillSaleRoModel";
import { IDetailList } from "../bmsBillSaleRoType";
import useNavModel, { RouterParamType } from '@/model/navModel';
import { useVrmPurchaseRoDetailsModel } from '@/views/vrmBill/vrmBillPurchaseRo/vrmBillPurchaseRoModel'

export const TableBox: FC<RouterParamType> = () => {
    const { detailLookList } = useBmsSaleRoDetailModel();
    const { goToSaleDetail } = useVrmPurchaseRoDetailsModel()
    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { branch } = detailsInfo
    const columns: ColumnsType<IDetailList> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '销售单号',
            width: 100,
            dataIndex: 'saleCode',
            fixed: "left",
            render: (t) => <Tooltip placement="topLeft" title={t} arrowPointAtCenter>
                <p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); goToSaleDetail(t, branch) }}>{t}
                </p></Tooltip>
        }, {
            title: '配件编码',
            width: 100,
            dataIndex: 'materialCode',
            fixed: "left",
        }, {
            title: '配件名称',
            width: 100,
            dataIndex: 'materialName',
            fixed: "left",
            render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{text}</p></Tooltip>,

        }, {
            title: '单位',
            width: 60,
            dataIndex: 'unitName',
        }, {
            title: '销售数量',
            width: 80,
            dataIndex: 'saleNum',
        }, {
            title: '销售单价',
            width: 100,
            dataIndex: 'salePrice',
        }, {
            title: '退货数量',
            width: 100,
            dataIndex: 'num',
        }, {
            title: '退货单价',
            width: 100,
            dataIndex: 'price',
        }, {
            title: '退货金额',
            width: 100,
            dataIndex: 'amount',
        }, {
            title: '已退数量',
            width: 100,
            dataIndex: 'sreturnNum',
        }, {
            title: '仓库',
            width: 120,
            dataIndex: 'warehouseName',
        }, {
            title: '货位',
            width: 120,
            dataIndex: 'shelfCode',
        }, {
            title: '备注',
            width: 200,
            dataIndex: 'note',
            fixed: 'right',
        }
    ];
    return (
        <YhBox title="配件信息" style={{ marginBottom: "75px" }}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowKey={record => record.materialCode as string}

                columns={columns}
                dataSource={detailLookList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}